import { makeStyles } from "@material-ui/core/styles";
import { Box, Grid, Typography } from "@material-ui/core";
import { FieldSetBox } from "../fieldSetBox";
import { formatCurrencyField, formatNumberField, getStringOrDefault } from "../../utils/utils";
import { getLabelForPropertyTypeValue } from "../../utils/constants";
import { ReportField } from "./reportField";
import { observer } from "mobx-react";

const useStyles = makeStyles(() => ({
  imgPlaceHolder: {
    border: "1px solid #656565",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    width: "800px",
    height: "300px",
  },
  addressTypography: {
    color: "black",
    fontWeight: "bold",
    fontSize: "16px",
    textAlign: "left",
    paddingLeft: "16px",
    display: "flex",
    alignItems: "center",
    height: "36px",
  },
}));

interface SubjectPropertyBoxProps {
  recommendedImage: string;
  address: string;
  internalValuationReview: any;
}

export const SubjectPropertyBox = observer(({ recommendedImage, address, internalValuationReview }: SubjectPropertyBoxProps) => {
  const classes = useStyles();

  return (<FieldSetBox title="Subject Property">
    <Box display="flex" flexDirection="row">
      {recommendedImage && <div style={{
        width: "800px",
        height: "300px",
        backgroundImage: `url(${recommendedImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        border: "1px solid #656565"
      }}></div>}
      {!recommendedImage && <div className={classes.imgPlaceHolder}><p>No Image Available</p></div>}
      <Grid container>
        <Grid item xs={12}>
          <ReportField label="Address" removeRightBorder>
            <Typography className={classes.addressTypography}>
              {address}
            </Typography>
          </ReportField>
        </Grid>
        <Grid item xs={4}>
          <ReportField label="Bedroom" value={formatNumberField(internalValuationReview.beds)} />
        </Grid>
        <Grid item xs={4}>
          <ReportField label="BathRoom" value={formatNumberField(internalValuationReview.baths)} />
        </Grid>
        <Grid item xs={4}>
          <ReportField label="Parking" value={formatNumberField(internalValuationReview.parking)} removeRightBorder />
        </Grid>
        <Grid item xs={4}>
          <ReportField label="Living Area" value={formatNumberField(internalValuationReview.livingArea)} />
        </Grid>
        <Grid item xs={4}>
          <ReportField label="Lot area" value={formatNumberField(internalValuationReview.landArea)} />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="Year Built"
            value={formatNumberField(internalValuationReview.yearBuilt)}
            removeRightBorder
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField label="Property Type" value={getStringOrDefault(getLabelForPropertyTypeValue(internalValuationReview.propertyType))} />
        </Grid>
        <Grid item xs={4}>
          <ReportField label="Zoning" value={getStringOrDefault(internalValuationReview.subjectZoning)} />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="County FIPS"
            value={getStringOrDefault(internalValuationReview.countyFips)}
            removeRightBorder
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField label="HOA fees" value={formatCurrencyField(internalValuationReview.hoaFees)} />
        </Grid>
        <Grid item xs={8}>
          <ReportField
            label="Parcel Number"
            value={getStringOrDefault(internalValuationReview.parcelNo)}
            removeRightBorder
          />
        </Grid>
      </Grid>
    </Box>
  </FieldSetBox>);
});